import FootballState from "../../../../football/state/football-state";
import Rule from "../../../../common/rule";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

export default class FlagPatComplete extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            fragment.associatedState === FootballState.PatCompleted
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const patTryFragment = play.getFirstFragment(FootballState.PatTry);

        gameContext.increaseTeamPossessionScore(
            patTryFragment.getScoringPoints()
        );
        ruleContext.playPoints = patTryFragment.getScoringPoints();

        // Without kickoffs the ball goes straight to the other team after a
        // PAT. With kickoffs enabled the scoring team keeps it to kick off,
        // and the receiving team takes over on the kickoff outcome instead;
        // switching here would have the wrong team kicking off. Tackle's
        // equivalent rule likewise never switches possession.
        if (isKickoffEnabled(gameContext)) return;

        gameContext.switchPossession();
    }
}
